import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';

export const COOKIEBOT_ID = new InjectionToken<string>('COOKIEBOT_ID');
export const URL_UPDATE = new InjectionToken<Subject<string>>('URL_UPDATE');
